import { render, staticRenderFns } from "./APPurHistoryForReturn.vue?vue&type=template&id=db0212a4&"
import script from "./APPurHistoryForReturn.vue?vue&type=script&lang=js&"
export * from "./APPurHistoryForReturn.vue?vue&type=script&lang=js&"
import style0 from "./APPurHistoryForReturn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APPurHistoryForReturn.vue"
export default component.exports